<div class="forgot-wrapper">
    <!-- Background shapes -->
    <div class="shape shape-1"></div>
    <div class="shape shape-2"></div>
    <div class="shape shape-3"></div>

    <div class="glass-card">
        <div class="logo">
            <img src="./assets/media/msis/main-logo.png" alt="MSIS INC" />
        </div>
        <h1>Forgot Password</h1>
        <p class="subtitle">Enter your email to reset your password</p>

        <div *ngIf="userNotFoundError === false" class="error-banner">
            Email you have provided doesn't match our records
        </div>

        <form [formGroup]="formGroup">
            <div class="field">
                <label for="email">Email</label>
                <input type="email" formControlName="email"
                    placeholder="Enter your email"
                    [class.field-error]="isControlInvalid('email')"
                    [class.field-valid]="isControlValid('email')" />
            </div>
            <div class="button-row">
                <a routerLink="/login" class="btn-cancel">Back to Login</a>
                <button [disabled]="formGroup.get('email').invalid"
                    class="btn-submit" (click)="submit()">
                    Reset Password
                </button>
            </div>
        </form>
    </div>
</div>
<p-toast key="bc" position="bottom-right"></p-toast>
